module.exports = __webpack_public_path__ + "img/alone.cd762c02.png";